<template>
	<article 
		ref="toggleItemWrapper"
		:id="id" 
		:class="[
			'dc-post-grid-card faq-card light-bg-theme has-shadow-mobile', 
			activeClass, 
			contentOpenClass
		]">
		<div class="toggle-wrapper">
			<h3 
				ref="toggleTriggerWrapper"
				class="toggle-title toggle-section-wrapper"
				@click.stop.prevent="toggle">
				<a 
					href="#" 
					class="question-title" 
					:aria-expanded="active" 
					:aria-controls="responseId" 
					@click.stop.prevent="toggle">
					<span class="question">{{ question }}</span>
					<span class="link read-more-link expand">
						<span class="screen-reader-text">Read more</span>
					</span>
				</a>
			</h3>
			<div 
				v-if="response"
				ref="toggleContentWrapper"
				:id="responseId" 
				class="question-response toggle-content toggle-section-wrapper" 
				:aria-hidden="!active">
				<div ref="toggleContentWrapperInner" v-html="response"></div>
			</div>
		</div>
	</article>
</template>

<script>
import { Toggleable } from '@dc-post-grid/mixins/Toggleable';
export default {
	mixins: [ Toggleable ],
	props: {
	    id: {
	      type: String|Number,
	      required: true
	    },
		question: {
	      type: String,
	      required: true
	    },
		response: {
	      type: String,
	      required: true
	    },
	},
	computed: {
		responseId() {
			return 'response-' + this.id;
		},
	}
}
</script>